import { webApp } from '../../types/webapp';
import type { ReduxState as State } from '../index';

export const getDogs = (state: State): webApp.V5Dog[] => state.dogs.dogs;
